const typographyPlugin = require('../../lib/utils/tailwind/typography.plugin');
const withBrandPrefix = require('../../lib/utils/tailwind/withBrandPrefix');
const fontSizeVariantsPlugin = require('../../lib/utils/tailwind/fontSizeVariants.plugin');

const colorsConfig = require('./configs/tailwind.colors');
const typographyConfig = require('./configs/tailwind.typography');
const proseConfig = require('./configs/tailwind.prose');

const brand = 'hn';

const fontFamily = {
  primary: `var(--font-hn-primary), Arial, sans-serif`,
  secondary: `Arial, sans-serif`,
};

exports.theme = {
  extend: {
    ...withBrandPrefix(brand, {
      fontFamily,
      colors: colorsConfig,
    }),
    typography: proseConfig(typographyConfig, { brand }),
    maxWidth: {
      tabloid: '980px',
    },
  },
};

exports.variants = {};

exports.safelist = [];

exports.plugins = [typographyPlugin(typographyConfig, { brand }), fontSizeVariantsPlugin];
